var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5866 5.12558L8.91708 7.43989V0H7.29572V7.43989L4.62624 5.12558L3.47977 6.11952L8.1064 10.1306L12.733 6.11952L11.5866 5.12558ZM16.2136 12.6521V9.84079H14.5922V12.6521H1.62136V9.84079H0V12.6521C0 13.4284 0.725907 14.0577 1.62136 14.0577H14.5922C15.4877 14.0577 16.2136 13.4284 16.2136 12.6521Z"}));
}

Download.defaultProps = {"width":"17","height":"15","viewBox":"0 0 17 15"};

module.exports = Download;

Download.default = Download;
